import React,{useState} from 'react';
import Nav from '../elements/nav/Nav';
// import Footer from '../elements/footer/Footer';
import './tool-cssButton.css'

function CssButton() {
    //General
    const [btnClass, setBtnClass] = useState("btn-css");

    // Text
    const [BtTf, setBtTf] = useState(true);
    const [btnText, setBtnText] = useState("Button");
    const [textSize, setTextSize] = useState(20);
    const [letterSpacing, setLetterSpacing] = useState(2);
    const [textFamily, setTextFamily] = useState("Courier New");
    const [textColor, setTextColor] = useState("#ffffff");
    const [boldFont, setBoldFont] = useState(true);
    const [italicFont, setItalicFont] = useState(false);

    // Padding
    const [Bp, setBp] = useState(false);
    const [BpP, setBpP] = useState(false);
    const [BgP, setBgP] = useState(10);
    const [BpT, setBpT] = useState(5);
    const [BpR, setBpR] = useState(5);
    const [BpB, setBpB] = useState(5);
    const [BpL, setBpL] = useState(5);

    // Border
    const [Bb, setBb] = useState(false);
    const [BYN, setBYN] = useState(false);
    // const [BbSp, setBbSp] = useState(false);
    // const [BbSg, setBbSg] = useState("solid");
    const [BbW, setBbW] = useState(2);
    const [BbS, setBbS] = useState("solid");
    const [BbC, setBbC] = useState("white");

    // Border redius
    const [Br, setBr] = useState(false);
    const [BrP, setBrP] = useState(false);
    const [BgR, setBgR] = useState(10);
    const [BrTL, setBrTL] = useState(10);
    const [BrTR, setBrTR] = useState(10);
    const [BrBL, setBrBL] = useState(10);
    const [BrBR, setBrBR] = useState(10);

    // Text-shadow
    const [TsTf, setTsTf] = useState(false);
    const [TsYN, setTsYN] = useState(false);
    const [TXaxis, setTXaxis] = useState(0);
    const [TYaxis, setTYaxis] = useState(0);
    const [TSblur, setTSblur] = useState(5);
    const [TScolor, setTScolor] = useState("gray");

    // Box-shadow
    const [BsTf, setBsTf] = useState(false);
    const [BsYN, setBsYN] = useState(false);
    const [Xaxis, setXaxis] = useState(0);
    const [Yaxis, setYaxis] = useState(0);
    const [Sblur, setSblur] = useState(5);
    const [Scolor, setScolor] = useState("gray");
    const [Splace, setSplace] = useState(false);

    // Background colour
    const [BbCd, setBbCd] = useState(false);
    const [BbCs, setBbCs] = useState(true);
    const [BbCg, setBbCg] = useState(false);
    const [BbCgS, setBbCgS] = useState("to bottom");
    const [BbCgA, setBbCgA] = useState(180);
    const [BbCsV, setBbCsV] = useState("#1B998B");
    const [BbCgFv, setBbCgFv] = useState("red");
    const [BbCgSv, setBbCgSv] = useState("gray")


    //Inline css
    const btnstyle ={
        padding: BpP? `${BpT}px ${BpR}px ${BpB}px ${BpL}px` : `${BgP}px`,
        
        fontSize: `${textSize}px`,
        fontFamily: `${textFamily}`,
        fontWeight: boldFont? `bold` : ``,
        letterSpacing: `${letterSpacing}px`,
        fontStyle: italicFont? `italic` : ``,
        color: `${textColor}`,

        border: BYN? `none` : `${BbW}px ${BbS} ${BbC}`,
        borderRadius: BrP? `${BrTL}px ${BrTR}px ${BrBR}px ${BrBL}px`:`${BgR}px`,

        backgroundColor: `${BbCsV}`,
        backgroundImage: BbCg? `linear-gradient(${(BbCgS === "angle")? `${BbCgA}deg`:`${BbCgS}`}, ${BbCgFv}, ${BbCgSv})`: `none`,

        boxShadow: BsYN? `none` : `${Splace? "inset":""} ${Xaxis}px ${Yaxis}px ${Sblur}px ${Scolor}`,
        textShadow: TsYN? `none` : `${TXaxis}px ${TYaxis}px ${TSblur}px ${TScolor}`
    }

    return(
        <>
            <Nav />

            <div className='main-hold'>
                <div className='main-hold-2'>

                    <div className='div-input main-hold-2-1'>

                        <div className='btn-output-div-hold-mob'>
                            
                            <div className='head-div'>
                                <p>Button demo!</p>
                            </div>
                        
                            <div className='btn-output-div'>

                                <button className='css-btn' style={btnstyle} >{btnText}</button>
                                
                            </div>
                        </div>

                        <div className='head-div'>
                            <p>Button css properties!</p>
                        </div>

                        <div className='btn-text-div btn-css-style-div'>

                            <div className='btn-css-style-heading'>
                                <input type="checkbox" checked={BtTf} onChange={()=>setBtTf(!BtTf)} />
                                <h5>Button text</h5>
                            </div>

                            {(BtTf)? (<div className='btn-text-div-main'>
                                <div className='size-100-div'>

                                    <div className='size-50-div padding-1'>
                                        <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                            <label htmlFor='btn-text'>Button text</label>
                                            <input type="text" value={btnText} onChange={(e)=>setBtnText(e.target.value)} />
                                        </div>
                                    </div>

                                    <div className='size-50-div padding-1'>
                                        <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                            <label htmlFor='btn-text'>Button class</label>
                                            <input type="text" value={btnClass} onChange={(e)=>setBtnClass(e.target.value)} />
                                        </div>
                                    </div>
                                    
                                </div>

                                <div className='size-100-div'>

                                    <div className='size-50-div padding-1'>
                                        <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                            <label htmlFor="text-size">Letter spacing: {letterSpacing}px</label>
                                            <input type="range" min="0" max="25" value={letterSpacing} onChange={(e)=>setLetterSpacing(e.target.value)} />
                                        </div>
                                    </div>

                                    <div className='size-50-div padding-1'>
                                        <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                            <label htmlFor="text-size">Text size: {textSize}px</label>
                                            <input type="range" min="1" max="75" value={textSize} onChange={(e)=>setTextSize(e.target.value)} />
                                        </div>
                                    </div>
                                    
                                </div>

                                <div className='size-100-div'>
                                    <div className='size-50-div padding-1'>
                                        <div className='select-label-input-div flex-d-col' value={textFamily} onChange={(e)=> setTextFamily(e.target.value)}>
                                            
                                            <label htmlFor='text-name'>Text family:&nbsp; </label>
                                            <select name='text-name' >
                                                <option value="Arial">Arial</option>
                                                <option value="Arial Black">Arial Black</option>
                                                <option value="Comic Sans MS">Comic Sans MS</option>
                                                <option value="Courier New">Courier New</option>
                                                <option value="Georgia">Georgia</option>
                                                <option value="Impact">Impact</option>
                                                <option value="Times New Roman">Times New Roman</option>
                                                <option value="Trebuchet MS">Trebuchet MS</option>
                                                <option value="Verdana">Verdana</option>
                                            </select>

                                        </div>
                                    </div>

                                    <div className='size-50-div padding-1'>
                                        <div className='color-label-input-div'>
                                            <label htmlFor='text-color'>Text color: &nbsp;</label>
                                            <input type='color' value={textColor} onChange={(e)=> setTextColor(e.target.value)} />
                                        </div>
                                    </div>
                                </div>

                                <div className='size-100-div'>
                                    <div className='size-50-div padding-1'>
                                        <div className='yes-no-div'>
                                            <label htmlFor="inset">Bold font : &nbsp; </label>
                                            <input type="checkbox" checked={boldFont} onChange={()=>setBoldFont(!boldFont)} />
                                        </div>
                                    </div>

                                    <div className='size-50-div padding-1'>
                                        <div className='yes-no-div'>
                                            <label htmlFor="inset">Italic font : &nbsp; </label>
                                            <input type="checkbox" checked={italicFont} onChange={()=>setItalicFont(!italicFont)} />
                                        </div>
                                    </div>
                                </div>
                            </div>):("")
                            }
                            
                        </div>

                        <div className='btn-text-shadow-div btn-css-style-div'>

                            <div className='btn-css-style-heading'>
                                <input type="checkbox" checked={TsTf} onChange={()=>setTsTf(!TsTf)} />
                                <h5>Text-shadow</h5>
                            </div>
                             
                            {(TsTf) ? (<div className='btn-text-shadow-div-main'>
                                <div className='size-100-div'>
                                    <div className='size-50-div padding-1'>
                                        <div className='yes-no-div'>
                                            <label htmlFor="inset">No text-shadow : &nbsp; </label>
                                            <input type="checkbox" checked={TsYN} onChange={()=>setTsYN(!TsYN)} />
                                        </div>
                                    </div>
                                </div>

                                {TsYN ? (""):(<>
                                    <div className='size-100-div'>
                                        <div className='size-50-div padding-1'>
                                            <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                <label htmlFor="x-axis">X Axis in pixel: {TXaxis}px</label>
                                                <input type="range" min="-150" max="150" value={TXaxis} onChange={(e)=>setTXaxis(e.target.value)} />
                                            </div>
                                        </div>
                
                                        <div className='size-50-div padding-1'>
                                            <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                <label htmlFor="y-axis">Y Axis in pixel: {TYaxis}px</label>
                                                <input type="range" min="-150" max="150" value={TYaxis} onChange={(e)=>setTYaxis(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='size-100-div'>

                                        <div className='size-50-div padding-1'>
                                            <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                <label htmlFor="blur">Shadoe blur: {TSblur}px</label>
                                                <input type="range" min="0" max="50" value={TSblur} onChange={(e)=>setTSblur(e.target.value)} />
                                            </div>
                                        </div>

                                        <div className='size-50-div padding-1'>
                                            <div className='color-label-input-div'>
                                                <label htmlFor="colour">Colour: &nbsp; </label>
                                                <input type="color" value={TScolor} onChange={(e)=>setTScolor(e.target.value)} />
                                            </div>
                                        </div>

                                    </div>
                                </>)}
                                
                            </div>):("")}

                        </div>

                        <div className='btn-padding-div btn-css-style-div'>

                            <div className='btn-css-style-heading'>
                                <input type="checkbox" checked={Bp} onChange={()=>setBp(!Bp)} />
                                <h5>Pading</h5>
                            </div>

                            {(Bp)? (<div className='btn-padding-div-main'>
                                <div className='size-100-div'>
                                    <div className='size-50-div padding-1'>
                                        <div className='yes-no-div'>
                                            <label htmlFor="inset">4 Point input : &nbsp; </label>
                                            <input type="checkbox" checked={BpP} onChange={()=>setBpP(!BpP)} />
                                        </div>
                                    </div>
                                </div>

                                {(BpP)? (<>
                                        <div className='size-100-div'>
                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Padding top: {BpT}px</label>
                                                    <input type="range" min="0" max="65" value={BpT} onChange={(e)=>setBpT(e.target.value)} />
                                                </div>
                                            </div>
                        
                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Padding right: {BpR}px</label>
                                                    <input type="range" min="0" max="65" value={BpR} onChange={(e)=>setBpR(e.target.value)} />
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                        <div className='size-100-div'>
                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Padding bottom: {BpB}px</label>
                                                    <input type="range" min="0" max="65" value={BpB} onChange={(e)=>setBpB(e.target.value)} />
                                                </div>
                                            </div>
                                            
                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Padding left: {BpL}px</label>
                                                    <input type="range" min="0" max="65" value={BpL} onChange={(e)=>setBpL(e.target.value)} />
                                                </div>
                                            </div>
                    
                                        </div>
                                        
                                    </>) :
                                    
                                    (<>
                                        <div className='size-100-div'>
                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Button padding: {BgP}px</label>
                                                    <input type="range" min="0" max="65" value={BgP} onChange={(e)=>setBgP(e.target.value)} />
                                                </div>
                                            </div>

                                        </div>
                                    </>)  
                                }
                                
                            </div>

                            ):("")}


                        </div>

                        <div className='btn-border-div btn-css-style-div'>

                            <div className='btn-css-style-heading'>
                                <input type="checkbox" checked={Bb} onChange={()=>setBb(!Bb)} />
                                <h5>Border</h5>
                            </div>

                            {(Bb)? (<div className='btn-padding-div-main'>
                                <div className='size-100-div'>
                                    <div className='size-50-div padding-1'>
                                        <div className='yes-no-div'>
                                            <label htmlFor="inset">No border : &nbsp; </label>
                                            <input type="checkbox" checked={BYN} onChange={()=>setBYN(!BYN)} />
                                        </div>
                                    </div>

                                    {BYN? (""):(<>
                                        <div className='size-50-div padding-1'>
                                            <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                <label htmlFor="x-axis">Border width: {BbW}px</label>
                                                <input type="range" min="0" max="50" value={BbW} onChange={(e)=>setBbW(e.target.value)} />
                                            </div>
                                        </div>
                                    </>)}

                                </div>
                                {BYN? (""):(<>
                                    <div className='size-100-div'>
                                        <div className='size-50-div padding-1'>
                                            <div className='select-label-input-div btn-css-gen-bottom-lable-padding flex-d-col' value={BbS} onChange={(e)=> setBbS(e.target.value)}>
                                                <label htmlFor='text-name'>Border style: &nbsp;</label>
                                                <select name='text-name' >
                                                    <option value="solid">solid</option>
                                                    <option value="dotted">dotted</option>
                                                    <option value="dashed">dashed</option>
                                                    <option value="inset">inset</option>
                                                    <option value="outset">outset</option>
                                                    <option value="ridge">ridge</option>
                                                    <option value="groove">groove</option>
                                                    <option value="double">double</option>
                                                    <option value="none">none</option>
                                                    <option value="hidden">hidden</option>
                                                </select>
                                            </div>
                                        </div>
                                        
                                        <div className='size-50-div padding-1'>
                                            <div className='color-label-input-div'>
                                                <label htmlFor='text-color'>Color: &nbsp;</label>
                                                <input type='color' value={BbC} onChange={(e)=> setBbC(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </>)}
                                
                            </div>) 
                            : 
                            ("")}
                        </div>

                        <div className='btn-border-redius-div btn-css-style-div'>

                            <div className='btn-css-style-heading'>
                                <input type="checkbox" checked={Br} onChange={()=>setBr(!Br)} />
                                <h5>Border radius</h5>
                            </div>

                            {(Br)? (<div className='btn-padding-div-main'>
                                <div className='size-100-div'>
                                    
                                    <div className='size-50-div padding-1'>
                                        <div className='yes-no-div'>
                                            <label htmlFor="inset">4 Point input : &nbsp; </label>
                                            <input type="checkbox" checked={BrP} onChange={()=>setBrP(!BrP)} />
                                        </div>
                                    </div>
            
                                </div>

                                {(BrP)? (<>
                                        <div className='size-100-div'>
                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Top left: {BrTL}px</label>
                                                    <input type="range" min="0" max="100" value={BrTL} onChange={(e)=>setBrTL(e.target.value)} />
                                                </div>
                                            </div>
                                        
                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Top right: {BrTR}px</label>
                                                    <input type="range" min="0" max="100" value={BrTR} onChange={(e)=>setBrTR(e.target.value)} />
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                        <div className='size-100-div'>
                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Bottom left: {BrBL}px</label>
                                                    <input type="range" min="0" max="100" value={BrBL} onChange={(e)=>setBrBL(e.target.value)} />
                                                </div>
                                            </div>

                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Bottom right: {BrBR}px</label>
                                                    <input type="range" min="0" max="100" value={BrBR} onChange={(e)=>setBrBR(e.target.value)} />
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                    </>) :
                                    
                                    (<>
                                        <div className='size-100-div'>
                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Border radius: {BgR}px</label>
                                                    <input type="range" min="0" max="100" value={BgR} onChange={(e)=>setBgR(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                    </>)  
                                }
                                
                            </div>

                            ):("")}


                        </div>

                        <div className='btn-box-shadow-div btn-css-style-div'>

                            <div className='btn-css-style-heading'>
                                <input type="checkbox" checked={BsTf} onChange={()=>setBsTf(!BsTf)} />
                                <h5>Box-shadow</h5>
                            </div>
                             
                            {BsTf ? (<div className='btn-box-shadow-div-main'>

                                <div className='size-100-div'>
                                    <div className='size-50-div padding-1'>
                                        <div className='yes-no-div'>
                                            <label htmlFor="inset">No box-shadow : &nbsp; </label>
                                            <input type="checkbox" checked={BsYN} onChange={()=>setBsYN(!BsYN)} />
                                        </div>
                                    </div>
                                </div>

                                {BsYN? (""):(<>
                                    <div className='size-100-div'>
                                        <div className='size-50-div padding-1'>
                                            <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                <label htmlFor="x-axis">X Axis in pixel: {Xaxis}px</label>
                                                <input type="range" min="-200" max="200" value={Xaxis} onChange={(e)=>setXaxis(e.target.value)} />
                                            </div>
                                        </div>

                                        <div className='size-50-div padding-1'>
                                            <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                <label htmlFor="y-axis">Y Axis in pixel: {Yaxis}px</label>
                                                <input type="range" min="-200" max="200" value={Yaxis} onChange={(e)=>setYaxis(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='size-100-div'>
                                        <div className='size-50-div padding-1'>
                                            <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                <label htmlFor="blur">Shadoe blur: {Sblur}px</label>
                                                <input type="range" min="0" max="50" value={Sblur} onChange={(e)=>setSblur(e.target.value)} />
                                            </div>
                                        </div>

                                        <div className='size-50-div flex-div flex-d-col'>
                                            <div className='size-100-div padding-1'>
                                                <label htmlFor="colour">Colour:&nbsp;</label>
                                                <input type="color" value={Scolor} onChange={(e)=>setScolor(e.target.value)} />
                                            </div>

                                            <div className='size-100-div padding-1' >
                                                <label htmlFor="inset">Inset:&nbsp;</label>
                                                <input type="checkbox" checked={Splace} onChange={()=>setSplace(!Splace)} />
                                            </div>
                                        </div>
                                    </div>
                                </>)}
                                
                            </div>):("")}
                            
                        </div>

                        <div className='btn-background-color-div btn-css-style-div'>

                            <div className='btn-css-style-heading'>
                                <input type="checkbox" checked={BbCd} onChange={()=>setBbCd(!BbCd)} />
                                <h5>Background colour</h5>
                            </div>
                             
                            {(BbCd) ? (<div className='btn-box-shadow-div-main'>
                                <div className='size-100-div'>
                                    <div className='size-50-div padding-1'>
                                        <div className='yes-no-div'>
                                            <label htmlFor="inset">Solid : &nbsp; </label>
                                            <input type="checkbox" checked={BbCs} onChange={()=>setBbCs(!BbCs) & setBbCg(!BbCg)} />
                                        </div>
                                    </div>

                                    <div className='size-50-div padding-1'>
                                        <div className='yes-no-div'>
                                            <label htmlFor="inset">Gradient : &nbsp; </label>
                                            <input type="checkbox" checked={BbCg} onChange={()=>setBbCg(!BbCg) & setBbCs(!BbCs)} />
                                        </div>
                                    </div>
                                </div>

                                {BbCs? (<>
                                    <div className='size-100-div'>
                                        <div className='size-50-div padding-1'>
                                            <label htmlFor="colour">Colour : &nbsp; </label>
                                            <input type="color" value={BbCsV} onChange={(e)=>setBbCsV(e.target.value)} />
                                        </div>
                                    </div>
                                </>)
                                :
                                (<>
                                    <div className='size-100-div'>
                                        <div className='size-50-div padding-1'>
                                            <div className='select-label-input-div btn-css-gen-bottom-lable-padding flex-d-col' value={BbCgS} onChange={(e)=> setBbCgS(e.target.value)}>
                                                <label htmlFor='text-name'>Gradient Style: &nbsp;</label>
                                                <select name='text-name' >
                                                    <option value="to bottom">top to bottom </option>
                                                    <option value="to right">left to right</option>
                                                    <option value="to bottom right">top left to bottom right</option>
                                                    <option value="angle">angle</option>
                                                </select>
                                            </div>
                                        </div>

                                        {(BbCgS === "angle")? (<>
                                            <div className='size-50-div padding-1'>
                                                <div className='label-input-div btn-css-gen-bottom-lable-padding'>
                                                    <label htmlFor="x-axis">Angle: {BbCgA}deg</label>
                                                    <input type="range" min="0" max="360" value={BbCgA} onChange={(e)=>setBbCgA(e.target.value)} />
                                                </div>
                                            </div>
                                        </>):("")}

                                    </div>

                                    <div className='size-100-div'>
                                        <div className='size-50-div padding-1 flex-div'>
                                            <label htmlFor="colour">Start colour:&nbsp; </label>
                                            <input type="color" value={BbCgFv} onChange={(e)=>setBbCgFv(e.target.value)} />
                                        </div>

                                        <div className='size-50-div padding-1 flex-div'>
                                            <label htmlFor="colour">End colour:&nbsp; </label>
                                            <input type="color" value={BbCgSv} onChange={(e)=>setBbCgSv(e.target.value)} />
                                        </div>
                                    </div>
                                </>)}


                            </div>):("")}

                            
                            
                        </div>

                    </div>

                    <div className='div-output main-hold-2-2'>

                        <div className='btn-output-div-hold-normal'>
                            <div className='head-div'>
                                <p>Button demo!</p>
                            </div>
                        
                            <div className='btn-output-div'>

                                <button className='css-btn' style={btnstyle} >{btnText}</button>
                                
                            </div>
                        </div>


                        <div className='sub-head-div-1'>
                            <p><i className="fas fa-chevron-circle-right"></i>Copy the button HTML code!</p>
                        </div>

                        <div className='output-code-div'>
                            <pre>
                                <code>
                                    <span className='top-code'> &lt;button class="{btnClass}"&gt; {btnText} &lt;/button&gt;</span>
                                </code>
                            </pre>
                            
                        </div>

                        <div className='sub-head-div-1'>
                            <p><i className="fas fa-chevron-circle-right"></i>Copy the button CSS code!</p>
                        </div>

                        <div className='output-code-div'>
                            <pre>
                                <code>
                                    <span className='top-code'>.{btnClass} &#123;<br />  </span>

                                    <span className='body-code'>font-size: {textSize}px;<br />  </span>
                                    <span className='body-code'>font-family: {textFamily};<br />  </span>
                                    {boldFont? (<span className='body-code'>font-weight: bold;<br />  </span>) : ("") }
                                    {italicFont? (<span className='body-code'>font-style: italic;<br />  </span>) : ("") }

                                    <span className='body-code'>letter-spacing: {letterSpacing}px;<br />  </span>
                                    <span className='body-code'>color: {textColor};<br />  </span>

                                    <span className='body-code'>padding: {BpP? (<span>{BpT}px {BpR}px {BpB}px {BpL}px</span>) : (<span>{BgP}px</span>)};<br />  </span>

                                    <span className='body-code'>border: {BYN? (<span>none</span>): (<span>{BbW}px {BbS} {BbC}</span>)};<br />  </span>
                                    <span className='body-code'>border-radius: {BrP?(<span>{BrTL}px {BrTR}px {BrBR}px {BrBL}px</span>): (<span>{BgR}px</span>)};<br />  </span>

                                    <span className='body-code'>background-color: {BbCsV};<br />  </span>
                                    {BbCg? (<span className='body-code'>background-image: linear-gradient &#40;{(BbCgS === "angle")? (<span>{BbCgA}deg</span>):(<span>{BbCgS}</span>)}, {BbCgFv}, {BbCgSv}&#41;;<br />  </span>) : ("")}

                                    {BsYN? ("") : (<span className='body-code'>box-shadow: {Splace? "inset":""} {Xaxis}px {Yaxis}px {Sblur}px {Scolor};<br />  </span>) }
                                    {TsYN? ("") : (<span className='body-code'>text-shadow: {TXaxis}px {TYaxis}px {TSblur}px {TScolor};<br /></span>) }

                                    <span className='bottom-code'>&#125;</span>
                                </code>
                            </pre>
                        </div>
                        
                    </div>
                </div>
            </div>
        </>
    );
}

export default CssButton;